import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Box, useTheme } from "@material-ui/core";
import DataService from "../../../../Service";
import MaterialTable from "material-table";

function Expenses() {
  const classes = useStyles();

  const [expenses, setExpenses] = useState([]);
  const [assignmentName, setassignmentName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [sepecifiedelemetPrice, setSpecifiedelemetPrice] = useState("");
  const [coachingPgmPrice, setCoachingPgmPrice] = useState("");
  const [loading, setLoading] = useState(false);

  let urlElements = window.location.href.split('/');
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/supplier_expense_details`, params).then((response) => {

      setExpenses(response.expenses)
      setassignmentName(response.assignment_name)
      setOrgName(response.organisation_name)
      setSpecifiedelemetPrice(response.payment_terms)
      setCoachingPgmPrice(response.total_amount)
      setLoading(false);
    })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Box width="100%" display="flex">
        <Box width="100%" >
          <Box style={{display:"flex",justifyContent:"space-between"}}>
          <Typography variant="body1" className={classes.heading} style={{width:"40%" }}>
            Expenses
          </Typography>
          <Typography style={{width:"10%"}}>

          </Typography>
          <Typography variant="body1" className={classes.heading} style={{ width:"60%" }}>
            Frequency/Milestones
          </Typography>
          </Box>
          {/* <br /> */}
          {expenses.length > 0 && expenses.map((item, i) => (
            <Box
              key={`${item.title}-${i}`}
              width="100%"
              display="flex"
              justifyContent="space-between"
              mb="20px"
            ><Box style={{width:"40%",display:"flex",flexDirection:"column",gap:"0.25rem"}}>
              <Typography
                variant="body1"
                style={{ maxWidth: 260}}
                className={classes.bodyText}
              >
                {item.expense_name}
              </Typography>
              {item.description && <Typography
                variant="body1"
                style={{ maxWidth: 213,fontSize:"0.75rem"}}
                className={classes.bodyText}
              >
                {item.description}
              </Typography>}

            </Box>
              <Typography
                variant="body1"
                className={classes.bodyText}
                style={{ fontWeight: "bold",width:"10%" }}
              >
                {item.availability}
              </Typography>
              <Typography
                variant="body1"
                className={classes.bodyText}
                style={{ width:"60%" }}
              >
                {item.frequency||""}
              </Typography>
            </Box>
          ))}
        </Box>
        {/* <Box width="10%"></Box> */}
        {/* <Box width="40%">
          <Typography variant="body1" className={classes.heading}>
            Frequency/Milestones
          </Typography>
          {expenses.length > 0 && expenses.map((item, i) => (
            <Box
              key={`${item}-${i}`}
              width="100%"
              display="flex"
              justifyContent="space-between"
              mb="20px"
            >
              <Typography variant="body1" className={classes.bodyText}>
                {item.frequency}
              </Typography>
            </Box>
          ))}
        </Box> */}
      </Box>
      {/* 
      <Typography
        variant="body1"
        style={{
          fontSize: "12px",
          color: "#232323",
          opacity: ".75",
          lineHeight: "20px",
          maxWidth: 226,
        }}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiu
      </Typography> */}
    </div>
  );
}

export default Expenses;

const useStyles = makeStyles((theme) => ({
  bodyText: {
    fontSize: 14,
    color: "#232323",
  },heading: {
    fontSize: 14,
    marginBottom: 20,
    color: theme.palette.secondary.main,
    fontWeight: "bold",
  }
}));
